import { useDataSyncing } from '@dreryk/command-query-react-common';
import {
   Badge,
   BadgePosition,
   BadgeType,
   DataSyncWaitingEventInterceptor,
   DocIcon,
   Link,
   LinkSize,
} from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';
import { PatientId } from '../../../PrescriptionIssuingPanel.types';
import { useDraftPrescriptionsWatch } from '../DraftPrescriptionsForm.hooks';
import { DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';

import { PatientEntitlementsEventInterceptor } from './PatientEntitlementsEventInterceptor';

type PatientEntitlementsLinkProps = Pick<DraftPrescriptionsFormController, 'control'> & {
   readonly patientId: PatientId;
};

export const PatientEntitlementsLink = (props: PatientEntitlementsLinkProps): JSX.Element | null => {
   const draftPrescriptions = useDraftPrescriptionsWatch(props.control);
   return (
      <DataSyncWaitingEventInterceptor waitUntil={useDataSyncing()}>
         {(waiting) => (
            <PatientEntitlementsEventInterceptor draftPrescriptions={draftPrescriptions} patientId={props.patientId}>
               {(documentsMissingCount) =>
                  Boolean(documentsMissingCount) && (
                     <Link
                        disabled={waiting}
                        testId={'entitlementDocuments'}
                        label={draftPrescriptionsTranslationKeys.entitlementDocuments}
                        size={LinkSize.NORMAL}
                        icon={
                           <Badge
                              type={BadgeType.WARNING}
                              count={documentsMissingCount}
                              position={BadgePosition.TOP_RIGHT}
                              testId={'entitlementDocuments'}
                           >
                              <DocIcon />
                           </Badge>
                        }
                     />
                  )
               }
            </PatientEntitlementsEventInterceptor>
         )}
      </DataSyncWaitingEventInterceptor>
   );
};
